import src from "IMAGE";
export default { src, width: 664, height: 200, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQUlEQVR42h2KQQrAIBADQ1PXU6u04kW8KQi+QPD/71L3EEIyg9HvmaI0UDxov90ONC8uzYOSWIM3WU/aX8UDdItbcb8Cy+uAYqcAAAAASUVORK5CYII="};
